import React, { useState } from "react";
import axios from "axios";
import { App, Card, Input, Button, Typography, Checkbox, Divider } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import "./SignupPage.css";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode"; // Install via: npm install jwt-decode

const { Title, Text, Link } = Typography;

const SignupPage = () => {
  const { notification, message } = App.useApp();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const handleSignup = async () => {
    if (!name || !username || !password || !confirmPassword) {
      message.warning("Please fill all fields");
      return;
    }

    if (password !== confirmPassword) {
      message.warning("Passwords do not match");
      return;
    }

    if (!isTermsChecked) {
      return notification.warning({
        message:
          "Please confirm your agreement to the privacy policy and terms.",
      });
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Auth/register`,
        {
          Name: name,
          Username: username,
          Password: password,
          ConfirmPassword: confirmPassword,
        }
      );

      // Handle success (e.g., show success message, redirect user, etc.)
      if (
        (response.data.data || {}).credentials &&
        response.data.data.credentials.token
      ) {
        localStorage.setItem("token", response.data.data.credentials.token);
        localStorage.setItem("user", JSON.stringify(response.data.data));
        navigate("/dashboard/home");
      }
      message.success("Registration successful!");
    } catch (error) {
      console.error("Registration failed:", error);

      const errorMsg =
        error.response?.data?.message ||
        "Something went wrong during registration.";
      console.log(errorMsg);
      notification.warning({
        message: errorMsg,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    // if (!isTermsChecked) {
    //   return notification.warning({
    //     message:
    //       "Please confirm your agreement to the privacy policy and terms.",
    //   });
    // }

    setLoading(true);

    try {
      const decoded = jwtDecode(credentialResponse.credential);
      console.log(decoded);
      // Optional: Send to backend for token exchange/login
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Auth/google-login`,
        {
          IdToken: credentialResponse.credential,
        }
      );

      if (
        (response.data.data || {}).credentials &&
        response.data.data.credentials.token
      ) {
        localStorage.setItem("token", response.data.data.credentials.token);
        localStorage.setItem("user", JSON.stringify(response.data.data));
        navigate("/dashboard/home");
        message.success("Login successful!");
      }
    } catch (error) {
      console.error("Google login error:", error);
      message.error("Login failed");
    }
    setLoading(false);
  };

  return (
    <div className="signup-container">
      <Card className="signup-card">
        <div className="logo-container">
          <img src={require("../../assets/logo.png")} alt="logo" />
        </div>
        <Title level={3}>Create account</Title>
        <Text type="secondary">It’s free and only takes a few seconds.</Text>

        <div className="form-item">
          <Text strong>Name</Text>
          <Input
            placeholder="Enter your full name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="form-item">
          <Text strong>Email or Username</Text>
          <Input
            placeholder="Enter your email or username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="form-item">
          <Text strong>Password</Text>
          <Input.Password
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </div>

        <div className="form-item">
          <Text strong>Confirm Password</Text>
          <Input.Password
            placeholder="Confirm your password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </div>
        <Divider />
        <div className="form-item checkbox-item">
          <Checkbox
            checked={isTermsChecked}
            onChange={(e) => {
              setIsTermsChecked(e.target.checked);
            }}
          >
            I agree to <Link href="/privacy">privacy policy</Link> &{" "}
            <Link href="/terms">terms</Link>
          </Checkbox>
        </div>

        <Button
          type="primary"
          block
          className="signup-button"
          onClick={handleSignup}
          loading={loading}
        >
          Sign up free
        </Button>

        {process.env.REACT_APP_GOOGLE_CLIENT_ID ? (
          <div style={{ marginTop: "16px", textAlign: "center" }}>
            <GoogleLogin
              onSuccess={handleGoogleLoginSuccess}
              onError={() => message.error("Google login failed")}
            />
          </div>
        ) : (
          []
        )}

        <div className="signin-text">
          Already have an account? <Link href="/login">Sign in instead</Link>
        </div>
      </Card>
    </div>
  );
};

export default SignupPage;
